import React from 'react'
import {User} from 'data/types'
import _ from 'lodash'
import {userAvatarColor} from 'utils'

type UserAvatarProps = {
  user: User
  size?: number
  className?: string
}

export default function UserAvatar(props: UserAvatarProps) {
  const size = props.size ?? 7
  return (
    <div
      style={{backgroundColor: userAvatarColor(props.user)}}
      className={`flex flex-row rounded-full h-${size} w-${size} justify-center font-semibold items-center text-xs text-white`}
    >
      {_(props.user.firstName).first() ?? ''}
      {_(props.user.lastName).first() ?? ''}
    </div>
  )
}
